import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const props = {
    className: PropTypes.string,
    initialValue: PropTypes.string,
    onUpdateFilter: PropTypes.func.isRequired,
};

const FilterSearchInput = ({ className, initialValue, onUpdateFilter }) => {
    const { t } = useTranslation();

    const [searchKey, setSearchKey] = useState(initialValue);

    return (
        <Input
            className={className || ""}
            prefix={<SearchOutlined />}
            placeholder={t("search")}
            allowClear
            value={searchKey}
            onChange={(e) => {
                const { value } = e.target;
                setSearchKey(value);
                if (!value) {
                    onUpdateFilter({ searchKey: value, page: 1 });
                }
            }}
            onPressEnter={() => onUpdateFilter({ searchKey, page: 1 })}
        />
    );
};

FilterSearchInput.propTypes = props;

export default FilterSearchInput;
